/**
 * @file
 * A JavaScript file for the site.
 *
 * 
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:

// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {

  $('.form-collapsible__trigger, .button-text--close').each(function(){

    $(this).click(function(){
      var $targetContainer = $(this).closest( '.form-collapsible' );
      $targetContainer.toggleClass( "expanded" );
    });

  });

  $(document).on('click', '.appointment-form-close', function(e){
      e.preventDefault();
      var $targetContainer = $(this).closest( '.form-collapsible' );
      $targetContainer.toggleClass( "expanded" );
  });

}(jQuery));